<template>
  <div class="c-aed-ownerOtherAED">
    <div class="o-grid o-grid--gutter-small">
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <h4 class="c-aed-adminChange__text-label o-heading o-heading--size-4">
            {{
              translationsOwnerModalCancel.doYouWantToCancelOtherAEDsConnectedTo
            }}
          </h4>
        </div>
        <div class="o-grid__item o-grid__item--12">
          <ul
            v-if="pendingFadderItems.length > 0"
            class="c-aed-ownerOtherAED__list"
          >
            <li
              class="c-aed-ownerOtherAED__item"
              v-for="item in pendingFadderItems"
              :key="item.id"
              @click="toggleItem(item.id)"
              @keyup.enter="toggleItem(item.id)"
              :title="item.address"
              tabindex="0"
            >
              <div
                class="o-grid o-grid--gutter-small o-grid--align-items-center"
              >
                <div class="o-grid__group">
                  <div class="o-grid__item o-grid__item--10">
                    <div class="c-aed-ownerOtherAED__item-name">
                      {{ item.address }}
                    </div>
                    <div class="c-aed-ownerOtherAED__item-email">
                      {{ translationsAEDdata.serialNumber }}
                      {{ item.serialNumber }}
                    </div>
                  </div>
                  <div
                    class="o-grid__item o-grid__item--grow-0 o-grid__item--align-right"
                  >
                    <div
                      class="o-button o-button--action o-button--round"
                      :class="{
                        'o-button--light': !pendingFadderSelectedItems.includes(
                          item.id
                        )
                      }"
                    >
                      <svg
                        class="o-svg-icon o-button__icon"
                        viewBox="0 0 64 64"
                        type="image/svg+xml"
                        v-if="pendingFadderSelectedItems.includes(item.id)"
                      >
                        <use
                          xlink:href="spritemap.svg#sprite-check-thinline"
                          x="0"
                          y="0"
                        ></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      section: "profile",
      searchTerm: ""
    };
  },
  computed: {
    ...mapGetters("aed", ["currentAED", "pendingFadder"]),
    ...mapState("owners", ["pendingFadderItems", "pendingFadderSelectedItems"]),
    ...mapState("translations", {
      translationsOwnerModalCancel: "ownerModalCancel",
      translationsAEDdata: "aedData"
    }),
    otherOwnerItems() {
      const items = this.pendingFadderItems.filter(
        item => item.id !== this.currentAED
      );
      return items;
    }
  },
  mounted() {
    this.makeCurrentAEDSelected();
  },
  methods: {
    makeCurrentAEDSelected() {
      if (!this.pendingFadderSelectedItems.includes(this.currentAED)) {
        this.$store.commit(
          "owners/addPendingFadderSelectedItems",
          this.currentAED
        );
      }
    },
    toggleItem(id) {
      if (this.pendingFadderSelectedItems.includes(id)) {
        this.$store.commit("owners/removePendingFadderSelectedItems", id);
      } else {
        this.$store.commit("owners/addPendingFadderSelectedItems", id);
      }
    }
  }
};
</script>

<style lang="scss">
.c-aed-ownerOtherAED {
  &__input {
    width: 100%;
  }
  &__list {
    border-top: 1px solid $s-cp-neutral-600;
    border-bottom: 1px solid $s-cp-neutral-600;
    max-height: 235px;
    overflow: auto;
  }
  &__item {
    padding: 15px 10px 20px;
    border-bottom: 1px solid $s-cp-neutral-600;
    cursor: pointer;
    overflow: hidden;

    &:last-child {
      border-color: transparent;
    }
  }

  &__item-name {
    color: $s-cp-sup-blue;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &__item-email {
    color: $s-cp-neutral-400;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
